/*eslint no-undef: "error"*/
<template>
  <div>
      <gmap-map :center="center" ref="myMap" :options="{streetViewControl: false}" :zoom="14" style="height: 100vh">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'mapa',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'http://backend.guepardos.co:3000/api',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajero: {},
      puntos: []
    }
  },
  mounted () {
    this.getData()
    this.interval = setInterval(function () {
      this.getData()
    }.bind(this), 10000)
  },
  methods: {
    getData () {
      let vm = this
      let url = vm.URL
      vm.$http.get(`https://mensajeria.guepardos.co/api/v2/mensajero/${vm.$route.params.id}`)
      .then(data => {
        vm.mensajero = data.body
        let query = {}
        if (vm.$route.query.inicio && vm.$route.query.fin) {
          query.where = {
            fecha: {
              between: [moment(vm.$route.query.inicio).utc().toISOString(), moment(vm.$route.query.fin).utc().toISOString()]
            },
            mensajeroId: {
              like: vm.$route.params.id
            }
          }
          query.order = 'fecha ASC'
          url = `https://mensajeria.guepardos.co/api/v2/locations`
          axios.post(url, query)
            .then(data => {
              vm.puntos = data.data
              vm.dibujarMultiplePuntos()
            })
            .catch(error => console.log(error))
        } else {
          query.where = {
            mensajeroId: {
              like: vm.$route.params.id
            }
          }
          query.limit = 1
          query.order = 'fecha DESC'
          query = JSON.stringify(query)
          url = `https://mensajeria.guepardos.co/api/v2/messengerPosition/${vm.$route.params.id}`
          axios.get(url)
            .then(data => {
              if (data.data.length === 1) {
                vm.lastPosition = data.data[0].metadata.coords
                vm.dibujarPuntos()
              }
            })
        }
      })
    },
    dibujarPuntos () {
      let vm = this
      vm.markers = []
      vm.center = new google.maps.LatLng(parseFloat(vm.lastPosition.latitude), parseFloat(vm.lastPosition.longitude))
      vm.markers.push({
        position: {
          lat: parseFloat(vm.lastPosition.latitude),
          lng: parseFloat(vm.lastPosition.longitude)
        },
        infoText: `Mensajero: ${vm.mensajero.nombre}`,
        icon: require('../assets/mensajero.png')
      })
    },
    dibujarMultiplePuntos () {
      let vm = this
      vm.markers = []
      vm.center = new google.maps.LatLng(parseFloat(vm.puntos[0].metadata.coords.latitude), parseFloat(vm.puntos[0].metadata.coords.longitude))
      let index = 0
      for (let punto of vm.puntos) {
        let fecha = moment(punto.fecha).format('YYYY-MM-DD HH:mm:ss')
        if (index === 0) {
          vm.markers.push({
            position: {
              lat: parseFloat(punto.metadata.coords.latitude),
              lng: parseFloat(punto.metadata.coords.longitude)
            },
            infoText: `Mensajero: ${vm.mensajero.nombre} - ${fecha}`,
            icon: require('../assets/car.png')
          })
        } else if (index === (vm.puntos.length - 1)) {
          vm.markers.push({
            position: {
              lat: parseFloat(punto.metadata.coords.latitude),
              lng: parseFloat(punto.metadata.coords.longitude)
            },
            infoText: `Mensajero: ${vm.mensajero.nombre} - ${fecha}`,
            icon: require('../assets/x.png')
          })
        } else {
          vm.markers.push({
            position: {
              lat: parseFloat(punto.metadata.coords.latitude),
              lng: parseFloat(punto.metadata.coords.longitude)
            },
            infoText: `Mensajero: ${vm.mensajero.nombre} - ${fecha}`,
            icon: require('../assets/point.png')
          })
        }
        index++
      }
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  },
  notifications: {
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
</style>



// WEBPACK FOOTER //
// Mensajero.vue?87cb9d96